<template>
  <div>
    <ul class="award-list mb-0 d-flex justify-content-center">
      <li
        class="mr-1"
        v-for="award in croppedList"
        :key="award.id"
      >
        <img
          class="cursor-pointer"
          :src="award.icon"
          :alt="award.name"
          :id="`award-${award.id}`"
          v-b-modal.awards-modal
        />
        <b-tooltip
          custom-class="font-size-xSmall"
          :target="`award-${award.id}`"
          triggers="hover"
        >
          {{ `${award.name} - ${award.description}` }}
        </b-tooltip>
      </li>
    </ul>

    <AwardModal
      :target="target"
      :type="type"
      v-if="awards && awards.length > 0"
    />
  </div>
</template>

<script>

import AwardModal from '@/components/awards/AwardModal'

export default {
  name: 'AwardList',
  props: ['type', 'target', 'awards'],
  components: {
    AwardModal
  },
  computed: {
    croppedList () {
      if (this.awards && this.awards.length > 8) {
        return this.awards.slice(0, 8)
      }
      return this.awards
    }
  }
}
</script>

<style lang="scss" scoped>

.award-list {
  li {
    img {
      width: 40px;
    }
  }
}

</style>
